import ModusServiceCollection from "../ModusServiceCollection";
import ResultNutrientElementModel from "../../models/modus/ResultNutrientElementModel";

/**
 * ResultNutrientElement collection
 */
export default class ResultNutrientElementCollection extends ModusServiceCollection {

  // Model that is contained in this collection.
  model() {
    return ResultNutrientElementModel;
  }

}
